<template>
    <div class="popup active" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>개인정보확인</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <h3 class="mt-none">대리인 정보</h3>
                    <ul class="table-box__list">
                        <li class="table-box__item item1">
                            <div class="table-box__head">이름</div>
                            <div class="table-box__desc">김수빈</div>
                        </li>

                        <li class="table-box__item item1">
                            <div class="table-box__head">휴대전화번호</div>
                            <div class="table-box__desc">010-1123-2434</div>
                        </li>
                        <li class="table-box__item item1">
                            <div class="table-box__head">이메일</div>
                            <div class="table-box__desc">haha@naver.com</div>
                        </li>
                    </ul>

                    <h3>환자 정보</h3>
                    <ul class="table-box__list">
                        <li class="table-box__item item1">
                            <div class="table-box__head">이름</div>
                            <div class="table-box__desc">김수빈</div>
                        </li>

                        <li class="table-box__item item1">
                            <div class="table-box__head">주민번호</div>
                            <div class="table-box__desc">101010-1102020</div>
                        </li>
                        <li class="table-box__item item1">
                            <div class="table-box__head">휴대전화번호</div>
                            <div class="table-box__desc">010-1123-2434</div>
                        </li>
                    </ul>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="popupBtn">취소</a>
                        <a href="javascript:;" class="main-button c-main">본인인증</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
            }
        },
    }
</script>